import {
  dehydrate,
  infiniteQueryOptions,
  QueryClient,
} from '@tanstack/react-query'
import type {
  UserGetRecentlyVisitedProjectsParams,
  UserListProjectsParams,
} from '../api'
import projectService from './user-project.service'
import { EProjectQueryKey } from './user-project.types'

export const getListProjectsOptions = (params: UserListProjectsParams) => {
  return {
    queryKey: [EProjectQueryKey.PROJECT, params],
    queryFn: () => projectService.getListProjects(params),
  }
}

export const getListProjectsOptionsPre = (params: UserListProjectsParams) => {
  return {
    queryKey: [EProjectQueryKey.PROJECT, params],
    queryFn: ({ pageParam = 0 }) => {
      return projectService.getListProjects({
        ...params,
        skip: pageParam * (params.limit || 10),
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getNextPageParam: (lastPage: any, allPages: any) => {
      const total = lastPage.data?.total || 0
      const currentLength = allPages.reduce(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc: number, page: any) => acc + (page.data?.projects?.length || 0),
        0,
      )
      return currentLength < total ? allPages.length : undefined
    },
    initialPageParam: 0,
  }
}

export const prefetchListProjects = async (params: UserListProjectsParams) => {
  const queryClient = new QueryClient()
  await queryClient.prefetchInfiniteQuery(
    infiniteQueryOptions(getListProjectsOptionsPre(params)),
  )
  return dehydrate(queryClient)
}

export const getProjectDetailsOptions = (token?: string) => {
  return {
    queryKey: [EProjectQueryKey.PROJECT, token],
    queryFn: () => projectService.getProjectDetails(token || ''),
    enabled: !!token,
  }
}

export const getRecentlyVisitedProjectsOptions = (
  params: UserGetRecentlyVisitedProjectsParams,
) => {
  return {
    queryKey: [EProjectQueryKey.RECENTLY_VISITED_PROJECTS, params],
    queryFn: () => projectService.getRecentlyVisitedProjects(params),
    staleTime: 1,
  }
}

export const getProjectCertDetailsOptions = (
  token?: string,
  enabled?: boolean,
) => {
  return {
    queryKey: [EProjectQueryKey.PROJECT_CERT_DETAILS, token],
    queryFn: () => projectService.getProjectCertDetails(token || ''),
    enabled: enabled !== undefined ? enabled && !!token : !!token,
  }
}
